export default function () {
    if (typeof plausible !== 'function') {
        return
    }
    plausible('pageview')
}
